import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getActiveInteraction } from '../interaction-metrics';
import getElementName from '../vc/vc-observer-new/get-unique-element-name';
var performanceEventObserver;
var selectorConfig = {
  id: true,
  testId: true,
  role: true,
  className: true
};
function getTestIdName(memoizedProps) {
  if (memoizedProps['data-testid']) {
    return "[data-testid=".concat(memoizedProps['data-testid'], "]");
  } else if (memoizedProps['data-test-id']) {
    return "[data-test-id=".concat(memoizedProps['data-testid'], "]");
  } else if (memoizedProps['data-vc']) {
    return "[data-vc=".concat(memoizedProps['data-vc'], "]");
  }
  return null;
}
function getUFOSegmentName(componentName, memoizedProps) {
  if (memoizedProps && memoizedProps['name']) {
    return "UFOSegment[name=".concat(memoizedProps['name'], "]");
  }
  return componentName;
}
function getReactComponentHierarchy(element) {
  var componentHierarchy = [];
  // Function to traverse up the fiber tree
  function traverseFiber(fiber) {
    var currentFiber = fiber;
    while (currentFiber) {
      if (currentFiber.type) {
        // Check if there's a display name or a function name
        var componentName = currentFiber.type.displayName || currentFiber.type.name;
        // checking when component name is bigger than the minimized name produced by react
        if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
          if (componentName === 'UFOSegment') {
            componentHierarchy.push(getUFOSegmentName(componentName, currentFiber.memoizedProps));
            break;
          }
          componentHierarchy.push(componentName);
        }
      }
      if (currentFiber.memoizedProps) {
        var dataIdInfo = getTestIdName(currentFiber.memoizedProps);
        if (dataIdInfo) {
          componentHierarchy.push(dataIdInfo);
          currentFiber = null;
          continue;
        }
      }
      currentFiber = currentFiber.return;
    }
  }
  // Access the reactFiber node from the HTML element
  var reactFiberKey = Object.keys(element).find(function (key) {
    return key.startsWith('__reactFiber$');
  });
  if (reactFiberKey) {
    var fiber = element[reactFiberKey];
    traverseFiber(fiber);
  }
  return componentHierarchy.reverse().join(' > ');
}
export var getPerformanceObserver = function getPerformanceObserver() {
  performanceEventObserver = performanceEventObserver || new PerformanceObserver(function (entries) {
    var list = entries.getEntries();
    var _iterator = _createForOfIteratorHelper(list),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        if (entry.name === 'click') {
          setInteractionPerformanceEvent(entry);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  return performanceEventObserver;
};
export var setInteractionPerformanceEvent = function setInteractionPerformanceEvent(entry) {
  var interaction = getActiveInteraction();
  if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
    var _interaction$responsi;
    if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
      var _interaction$responsi2, _interaction$responsi3;
      interaction.responsiveness = _objectSpread(_objectSpread({}, interaction.responsiveness), {}, {
        experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
        inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
      });
      if (interaction.ufoName === 'unknown') {
        if (entry.target) {
          var componentHierarchy = getReactComponentHierarchy(entry.target);
          interaction.unknownElementHierarchy = componentHierarchy;
        }
        interaction.unknownElementName = getElementName(selectorConfig, entry.target);
      }
    }
  }
};